import axios from '@/libs/axios';
import { MutationConfig, queryClient } from '@/libs/react-query';
import { useMutation } from '@tanstack/react-query';
import { ListQueryKey, Urls } from '../constant'; //

//
export interface CreationRequest {
  bank_name: string;
  card_num: string;
  open_bank: string;
  real_name: string;
  user_id: number;
}

export interface CreateResponse extends Response {
  data: null;
}

//
export const creation = (data: CreationRequest): Promise<CreateResponse> => {
  return axios.post(Urls.createUrl, data);
};

//
type UseCreateOptions = {
  config?: MutationConfig<typeof creation>;
};

export const useCreate = ({ config }: UseCreateOptions = {}) => {
  return useMutation({
    onSettled: () => {
      queryClient.invalidateQueries([ListQueryKey]);
    },
    mutationFn: creation,
    ...config,
  });
};
